import { Fragment } from 'react';
import { makeid } from 'utils/helpers/makeid';

import ReviewedItem from './reviewed-item';
import MessageItem from './message-item';
import CallItem from './call-item';
import s from './styles.module.scss';

import type { Grouped } from 'infrastructure/functions';
import type { IActivityComments } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { FC } from 'react';

const erroneousCommentGuid = 'erroneous-comment-guid';

interface CommentListProps {
  patientGuid: string;
  groupedComments: Grouped<IActivityComments>;
}

const CommentList: FC<CommentListProps> = ({
  patientGuid,
  groupedComments,
}) => {
  return (
    <ul data-cy="comment-list" className={s['comments-list']}>
      {Object.keys(groupedComments).map((date) => {
        const commentsOfDate = groupedComments[date];

        return (
          <Fragment key={makeid(5)}>
            <li
              data-cy="comments-day"
              className={s['comments-day']}
              key={date + makeid(5)}
            >
              <p>{date}</p>
            </li>
            {commentsOfDate.map((comment) => {
              const isTypeText = comment.type === 'text';
              const isMessageNull = comment.message === null;
              const isTypeCall = comment.type === 'call';
              const isMockComment = comment.guid.startsWith('id_');
              const isErroneousComment = comment.guid === erroneousCommentGuid;

              return (
                <Fragment key={makeid(5)}>
                  {isTypeText && isMessageNull && (
                    <ReviewedItem
                      comment={comment}
                      key={comment.guid + makeid(5)}
                    />
                  )}
                  {isTypeText && !isMessageNull && (
                    <MessageItem
                      comment={comment}
                      isMockComment={isMockComment}
                      key={comment.guid + +makeid(5)}
                      isErroneousComment={isErroneousComment}
                    />
                  )}
                  {isTypeCall && (
                    <CallItem
                      comment={comment}
                      patientGuid={patientGuid}
                      key={comment.guid + makeid(5)}
                    />
                  )}
                </Fragment>
              );
            })}
          </Fragment>
        );
      })}
    </ul>
  );
};
export default CommentList;
